export enum Access {
  Free = 'Free',
  Premium = 'Premium',
  Founder = 'Founder',
  Visitor = 'Visitor',
}

export interface Profile {
  userAccess: Access,
  userCompany?: string,
  id: string,
  userEmail: string,
  payments?: Payment[],
}

export const profileDefaults: Profile = {
  userAccess: Access.Visitor,
  userCompany: undefined,
  id: '',
  userEmail: '',
  payments: [],
}

export interface Payment {
  id: string,
  due_date: number,
  description: 'subscription_create' | 'subscription_update' | 'subscription_cycle',
  status: PaymentStatus,
  amount_due: number,
  created: number,
  link: string,
}

export enum PaymentStatus {
  RequiresPaymentMethod = 'requires_payment_method',
  RequiresConfirmation = 'requires_confirmation',
  RequiresAction = 'requires_action',
  Processing = 'processing',
  RequiresCapture = 'requires_capture',
  Canceled = 'canceled',
  Succeeded = 'succeeded',
}

export const STATUS_TRANSLATIONS = {
  [PaymentStatus.RequiresPaymentMethod]: 'payment-list-subscription-status-requires-payment-method',
  [PaymentStatus.RequiresConfirmation]: 'payment-list-subscription-status-requires-confirmation',
  [PaymentStatus.RequiresAction]: 'payment-list-subscription-status-requires-action',
  [PaymentStatus.Processing]: 'payment-list-subscription-status-processing',
  [PaymentStatus.RequiresCapture]: 'payment-list-subscription-status-requires-capture',
  [PaymentStatus.Canceled]: 'payment-list-subscription-status-canceled',
  [PaymentStatus.Succeeded]: 'payment-list-subscription-status-succeeded',
}
